export default Object.freeze({
  Minimal: 1,
  Low: 2,
  Medium: 3,
  HighCompleted: 4,
});
